<template>
	<div
		class="event-list-item-time"
		:class="[`-${variant}`]"
	>
		<div
			v-if="status === EVENT_STATUS.LIVE || competitionStageInfo"
			class="event-list-item-time__infos-top"
		>
			<div
				v-if="status === EVENT_STATUS.LIVE"
				class="event-list-item-time__live-badge"
			>
				<BadgeLive modifier="small" />
			</div>
			<div
				v-if="competitionStageInfo"
				class="event-list-item-time__competition-stage"
			>
				{{ competitionStageInfo.label }}
			</div>
		</div>
		{{ time }}
	</div>
</template>

<script>
import BadgeLive from '@shared/components/BadgeLive';
import { EVENT_STATUS } from '@shared/utils/eventUtils';

export default {
	name:       'EventListItemTime',
	components: { BadgeLive },
	props:      {
		status: {
			type:     String,
			required: true,
		},
		time: {
			type:     String,
			required: true,
		},
		competitionStageInfo: {
			type:    Object,
			default: null,
		},
		variant: {
			type:    String,
			default: 'single',
		},
	},
	data() {
		return {
			EVENT_STATUS,
		};
	},
};
</script>

<style lang="scss" scoped>
@import '@sass/variables';

.event-list-item-time {
	@include font-size(fs-60);
	display: flex;
	position: relative;
	flex-direction: column;
	justify-content: center;
	margin-bottom: $sp3;
	color: var(--color-grey-200);
	width: 100%;
	text-align: center;

	&.-volley {
		text-align: left;
	}

	@include size(md-up) {
		width: 140px;
		height: 100%;
		text-align: left;
		margin-bottom: 0;

		&::after {
			display: block;
			position: absolute;
			top: 50%;
			right: 0;
			width: 1px;
			height: 40%;
			transform: translateY(-50%);
			content: '';
			background-color: var(--color-grey-700);
		}
	}
}

.event-list-item-time__infos-top {
	display: flex;
	align-items: baseline;
	gap: $sp3;
	margin-bottom: $sp3;
}

// .event-list-item-time__competition-stage {}
</style>
